import React from 'react';
import { Box, Container } from '@mui/material';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import WhatsAppButton from '../Common/WhatsAppButton';
import HelpButton from '../Common/HelpButton';

interface LayoutProps {
  children: React.ReactNode;
  noPadding?: boolean;
}

const Layout: React.FC<LayoutProps> = ({ children, noPadding = false }) => {
  const location = useLocation();
  const isHome = location.pathname === '/';

  const disablePadding = noPadding || isHome;

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', width: '100%',
    overflowX: 'hidden'}}>
      <Header />
      <Box component="main" sx={{ flexGrow: 1 }}>
        {disablePadding ? (
          children
        ) : (
          <Container maxWidth="xl" sx={{ py: 4 }}>
            {children}
          </Container>
        )}
      </Box>
      <Footer />
      <WhatsAppButton />
      <HelpButton />
    </Box>
  );
};

export default Layout; 